import FormInputs from "../../../components/UI/FormInputs";

const NormalAbnormal = (props) => {
    const { field, setFormState, formState,setIsFormDirty } = props;
    const OPTIONS = [
        {
            label: "NORMAL",
            style:{},
        }
        ,
        {
            label: "ABNORMAL",
            style:{ backgroundColor: 'red', borderColor: 'red' },
        }
    ];
    let value = formState?.[field.id];
    if (typeof value === 'string') {
        try {
            const parsed = JSON.parse(value);
            //console.log('parsed',parsed);
            
            if (parsed && typeof parsed === 'object') {
                value = parsed;
            }
        } catch (e) {
        }
    }
    const handleOptionChange = (optionId, labelValue) => {
        if (setIsFormDirty) {
            setIsFormDirty(true);
          }
        setFormState({
            ...formState,
            [field.id]: {
                ...(value || {}),
                [optionId]: labelValue,
            },
        });
    };
    const handleSetAllLeft = () => {
        if (setIsFormDirty) {
            setIsFormDirty(true);
          }
        const updated = {};
        field.options.forEach((opt) => {
            updated[opt.id] = "NORMAL";
        });
        setFormState({
            ...formState,
            [field.id]: updated,
        });
    };

    return (
        <div className="card w-100 mb-0 pb-2 shadow-none border-0">
           {!props.isExam && (
            <div className="card-header sh_subaccordionheader d-flex justify-content-between align-items-center">
                <h6 className="text-sm mb-0">
                {field.label}
                {field.is_required ? <span className="text-danger">*</span> : ""}
                </h6>
            </div>
            )}

            <div className="card-body py-0 px-0">
                <table className="table table-bordered sh_tablenew table-sm mb-0">
                    <thead className="thead-light">
                        <tr>
                            <th style={{ width: "60%" }} className="text-start">
                                <a
                                    className="badge bg-blue-soft text-light cursor-pointer custom-btn"
                                    onClick={handleSetAllLeft}
                                >
                                    Set all to Normal
                                </a>
                            </th>
                            <th className="text-center">Normal</th>
                            <th className="text-center">Abnormal</th>
                        </tr>
                    </thead>
                    <tbody>
                        {field.options.map((opt, idx) => {
                            const selected =
                                value?.[opt.id] || "";

                            return (
                                <tr key={opt.id}>
                                    <td className="align-middle sh_emrradiotabletd">
                                        {opt.value || `Option ${idx + 1}`}
                                    </td>
                                    {OPTIONS.map((option) => (
                                        <td
                                            key={option.label}
                                            className="text-center align-middle"
                                        >
                                            <div className="form-check d-flex justify-content-center mb-0">
                                            <FormInputs 
                                                type={"Radio"}
                                                className={"form-check-input"}
                                                name={`${field.id}_${opt.id}`}
                                                value={selected === option.label}
                                                style={ selected === option.label?option.style:{}}
                                                changeHandler={() =>
                                                    handleOptionChange(opt.id, option.label)
                                                }
                                                />
                                            </div>
                                        </td>
                                    ))}
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default NormalAbnormal;
